import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {TabellaGiustAutoRecord} from "@commons/mapping/TabellaGiustAutoRecord";
import {GiustificazioneAutoRecord} from "@commons/mapping/GiustificazioneAutoRecord";
import {Calc, Coppia} from "@commons/mapping/Calc";
import {AccumuloRecord} from "@commons/mapping/AccumuloRecord";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {CachePresenze} from "@commons/mapping/CachePresenze";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";
import {GestionePlusData} from "@commons/services/presenze_calcolo/GestionePlusData";
import {Accumuli} from "@commons/services/presenze_calcolo/sub_calcolo/Accumuli";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";


export class GiuAutomatici {
    private readonly gestione: GestionePlusData;
    private readonly cache: CachePresenze;

    constructor(gestione: GestionePlusData, cache: CachePresenze) {
        this.gestione = gestione;
        this.cache = cache;
    }

    static cancelloGiuAutomatici = (cache: CachePresenze, day: PresenzeGiornataPlusRecord, tabella: TabellaGiustAutoRecord | null, tutti: boolean) => {
        // Cancello eventuali giustificativi con automatismo pari a <ta_eccedenteAutomatico> inseriti in precedenza
        const causaliXXX = [day.causaliHH, day.causaliQI];
        for (let indC = 0; indC < causaliXXX.length; ++indC) {
            const causali = causaliXXX[indC];
            for (let indGiu = 0; indGiu < causali.length; ++indGiu) {
                const causale = causali[indGiu];
                if (causale) {
                    const giu = cache.getGiustificativo(causale.codGiu);
                    if (giu) {
                        if (GiustificativoRecord.isAutomatico(giu)) {
                            if (tutti || tabella === null || TabellaGiustAutoRecord.usaGiu(tabella, giu.codGiu)) {
                                causali[indGiu] = null;
                            }
                        }
                    }
                }
            }
        }
        day.causaliHH = PresenzeGiornataPlusRecord.defrag(day.causaliHH);
        day.causaliQI = PresenzeGiornataPlusRecord.defrag(day.causaliQI);
    };

    static cancelloGiuTolleranza = (cache: CachePresenze, day: PresenzeGiornataPlusRecord) => {
        const causali = day.causaliHH;
        for (let indGiu = 0; indGiu < causali.length; ++indGiu)
            if (causali[indGiu]) {
                const giu = cache.getGiustificativo(causali[indGiu]!.codGiu);
                if (giu && GiustificativoRecord.isTolleranza(giu)) {
                    causali[indGiu] = null;
                }
            }
        day.causaliHH = PresenzeGiornataPlusRecord.defrag(day.causaliHH);
    };

    public applicaGiuAuto = (day: PresenzeGiornataPlusRecord,
                             tabella: TabellaGiustAutoRecord,
                             _calcoloMassivo: boolean,
                             cFasciaDiurna: Calc, cFasciaNotturna: Calc,
                             _calcPrevistoD: Calc,
                             _calcPrevistoN: Calc,
                             mancanteResiduo: number,
                             mancanteXGiuFS: PresenzeGiustificativo | null,
                             accumuliCHK: AccumuloRecord[] = []) => {
        const that = this;
        let countHH = 0;
        let countQI = 0;

        const result = {count: 0, countQI: 0, ricalcola: false};
        if (tabella) {
            let newCausaliHH: PresenzeGiustificativo[] = []; //PresenzeCausali
            let newCausaliQI: PresenzeGiustificativo[] = []; //PresenzeCausali
            let countNewCausaliHH = 0;
            let countNewCausaliQI = 0;
            const insNewCausali = function () {
                if (newCausaliHH.length > 1 || (newCausaliHH.length === 1 && PresenzeGiornataPlusRecord.posCausaleHH(day, newCausaliHH[0].codGiu) === -1)) {
                    countHH += PresenzeGiornataPlusRecord.addCausaliHH(day, newCausaliHH, GestionePlus.maxCausaliOre);
                }
                if (newCausaliQI.length > 1 || (newCausaliQI.length === 1 && PresenzeGiornataPlusRecord.posCausaleQI(day, newCausaliQI[0].codGiu) === -1)) {
                    countQI += PresenzeGiornataPlusRecord.addCausaliQI(day, newCausaliQI, GestionePlus.maxCausaliQI);
                }
                newCausaliHH = []; // svuoto array perché tale funzione viene chiamata per ogni singola giustificazione
                newCausaliQI = [];
                that.aggiornaSaldiAccumuli(day.week, day);
            };

            const copieArr = PresenzeGiornataPlusRecord.getCopieArrotondate(day);
            const calcLavoratoArrD = new Calc();
            const calcLavoratoArrN = new Calc();

            for (let indA = 0; indA < copieArr.length; ++indA) {
                calcLavoratoArrD.add(copieArr[indA].calc.getFlat(cFasciaDiurna));
                calcLavoratoArrN.add(copieArr[indA].calc.getFlat(cFasciaNotturna));
            }

            const copieEff = PresenzeGiornataPlusRecord.getCopieEffettive(day);
            const calcLavoratoEffD = new Calc();
            const calcLavoratoEffN = new Calc();

            for (let indE = 0; indE < copieEff.length; ++indE) {
                calcLavoratoEffD.add(copieEff[indE].calc.getFlat(cFasciaDiurna));
                calcLavoratoEffN.add(copieEff[indE].calc.getFlat(cFasciaNotturna));
            }

            for (let indRegola = 0; indRegola < tabella.regole.length; ++indRegola) {
                const regola = tabella.regole[indRegola];
                const giustificativo = that.cache.getGiustificativo(regola.codGiu);

                if (giustificativo) {
                    const c0 = GiustificativoRecord.hasStatus(giustificativo, that.gestione.elencoStatus);
                    const c1 = GiustificativoRecord.isGMCompliance(giustificativo, day);
                    const c3 = GiustificativoRecord.isDayCompliance(giustificativo, day);
                    const c4 = GiustificazioneAutoRecord.chkTipologiaGiornata(regola, day)
                    if (c0 && c1 && c3 && c4) {
                        const totaleHPrev = RiepilogoOrePlus.getTotaleHPrev(day.totali);
                        if (regola.controlloSuPrevisto === 'QUALSIASI' ||
                            (regola.controlloSuPrevisto === 'CON_PREVISTO' && totaleHPrev > 0) ||
                            (regola.controlloSuPrevisto === 'SENZA_PREVISTO' && totaleHPrev === 0)) {
                            let quantita = 0;
                            let intervalloDaTestare = null;

                            let posCausaleMLT = -1;
                            if (regola.codGiuDaSostituire) {
                                posCausaleMLT = PresenzeGiornataPlusRecord.posCausaleHH(day, regola.codGiuDaSostituire);
                            }
                            if (posCausaleMLT === -1) {
                                switch (regola.controllo) {
                                    case 'NESSUN_CONTROLLO':
                                        quantita = regola.ore * (GiustificativoRecord.isOrario(giustificativo) ? 60 : 1);
                                        // Solo per rilevazione manuale! ricalcolo la giornata
                                        // dal 29/01/2025 solo se il giustificativo in inserimento è di tipo orario
                                        if (day.arrotondateLocked && day.tipoRilevazione === 'MANUALE' && GiustificativoRecord.isOrario(giustificativo)) {
                                            result.ricalcola = true;
                                        }
                                        break;
                                    case 'COME_PREVISTO':
                                        if (totaleHPrev < giustificativo.valMax * 60 || giustificativo.valMax === 0) {
                                            quantita = totaleHPrev;
                                        } else {
                                            quantita = giustificativo.valMax * 60;
                                        }
                                        break;
                                    case 'COME_MANCANTE':
                                        let decurtaFS = false;
                                        if (mancanteXGiuFS) {
                                            mancanteResiduo = mancanteResiduo + mancanteXGiuFS.quantita * 60;
                                            decurtaFS = true;
                                        }
                                        const hMancanti = mancanteResiduo;// day.totali.hMancanti;
                                        if (hMancanti < giustificativo.valMax * 60 || giustificativo.valMax === 0) {
                                            quantita = hMancanti;
                                        } else {
                                            quantita = giustificativo.valMax * 60;
                                        }
                                        if (decurtaFS) {
                                            if (quantita >= mancanteXGiuFS!.quantita * 60) {
                                                PresenzeGiustificativo.setHHCC(mancanteXGiuFS!, 0);
                                            } else {
                                                PresenzeGiustificativo.setHHCC(mancanteXGiuFS!, (mancanteXGiuFS!.quantita * 60 - quantita) / 60.0); // Da capire se verosimile che ci sia un terzo giustificativo oltre a quello del festivo e quello in applicazione a copertura di mancante!
                                            }
                                        }
                                        break;
                                    case 'COME_INTERVALLO':
                                        intervalloDaTestare = new Coppia(GiustificazioneAutoRecord.getDalleXLavorate(regola)!, GiustificazioneAutoRecord.getAlleXLavorate(regola)!);
                                        quantita += calcLavoratoArrD.getCount(intervalloDaTestare.calc);
                                        quantita += calcLavoratoArrN.getCount(intervalloDaTestare.calc);
                                        break;
                                    case 'COME_INTERVALLO_EFF':
                                        intervalloDaTestare = new Coppia(GiustificazioneAutoRecord.getDalleXLavorate(regola)!, GiustificazioneAutoRecord.getAlleXLavorate(regola)!);
                                        quantita += calcLavoratoEffD.getCount(intervalloDaTestare.calc);
                                        quantita += calcLavoratoEffN.getCount(intervalloDaTestare.calc);
                                        break;
                                    case 'COME_ORDINARIO':
                                        quantita += RiepilogoOrePlus.getTotaleHOrd(day.totali!);
                                        break;
                                    case 'COME_ORDINARIO_D':
                                        quantita += day.totali!.hOrdDiurne;
                                        break;
                                    case 'COME_ORDINARIO_N':
                                        quantita += day.totali!.hOrdNotturne;
                                        break;
                                    case 'COME_EXTRA':
                                        quantita += RiepilogoOrePlus.getTotaleHEcc(day.totali!);
                                        break;
                                    case 'COME_EXTRA_D':
                                        quantita += day.totali!.hEccDiurne;
                                        break;
                                    case 'COME_EXTRA_N':
                                        quantita += day.totali!.hEccNotturne;
                                        break;
                                }

                                if (giustificativo.decimaleMultipliDi > 0) {
                                    // adeguo quantità in base alla regola propria del giustificativo
                                    const qMultiplo = giustificativo.decimaleMultipliDi;
                                    /*if (giustificativo.isOrario()) {
                                        qMultiplo *= 60.0;
                                        qMultiplo /= 100.0;
                                    }*/
                                    quantita = Math.floor(quantita / qMultiplo) * qMultiplo;
                                }

                                const c2 = GiustificativoRecord.isRangeValid(giustificativo, quantita, totaleHPrev, false);
                                if (c2) {
                                    const calcLavortatoD = regola.controllo === 'COME_INTERVALLO_EFF' ? calcLavoratoEffD : calcLavoratoArrD;
                                    const calcLavortatoN = regola.controllo === 'COME_INTERVALLO_EFF' ? calcLavoratoEffN : calcLavoratoArrN;
                                    // Prelevo mancante lavorato dai giustificativi caricati in precedenza (manuali)
                                    let mancanteLavorato = 0;
                                    if (regola.usaMancanteLavorato) {
                                        mancanteLavorato += PresenzeGiornataPlusRecord.getTotaleMancanteLavorato(day, that.cache);
                                        // Aggiungo eventuali giustificativi caricati dall'automatismo
                                        for (let indGiu = 0; indGiu < newCausaliHH.length; ++indGiu) {
                                            const causale = newCausaliHH[indGiu];
                                            if (causale && PresenzeGiustificativo.isValid(causale)) {
                                                mancanteLavorato += PresenzeGiornataPlusRecord.getMancanteLavorato(that.cache.getGiustificativo(causale.codGiu), causale.quantita);
                                            }
                                        }
                                    }

                                    const chkOreLavorate = GiustificazioneAutoRecord.chkOre(regola, calcLavortatoD, calcLavortatoN,
                                        regola.controlloSuOreLavorate,
                                        GiustificazioneAutoRecord.getDalleXLavorate(regola)!,
                                        GiustificazioneAutoRecord.getAlleXLavorate(regola)!,
                                        regola.oreRifXLavorate * 60, false, day, mancanteLavorato);
                                    const chkMancanti = GiustificazioneAutoRecord.chkOre(regola, calcLavortatoD, calcLavortatoN, regola.controlloSuOreMancanti,
                                        GiustificazioneAutoRecord.getDalleXMancante(regola)!,
                                        GiustificazioneAutoRecord.getAlleXMancante(regola)!,
                                        regola.oreRifXMancante * 60, true, day, mancanteLavorato);
                                    const chkAltroGiu = GiustificazioneAutoRecord.chkGiustificativo(regola, day.causaliHH, day.causaliQI);

                                    let quantitaCausale;
                                    if (GiustificativoRecord.isOrario(giustificativo)) {
                                        quantitaCausale = quantita / 60;
                                    } else {
                                        if (regola.controllo === 'NESSUN_CONTROLLO') {
                                            quantitaCausale = quantita;
                                        } else { // si tratta di una quantità oraria, perché derivante da un tipo di controllo orario (COME_PREVISTO, COME_MANCANTE o COME_INTERVALLO)
                                            quantitaCausale = quantita / 60;
                                        }
                                    }

                                    let chkAccumulo;
                                    if (regola.controlloAccumulo !== 'NESSUN_CONTROLLO') {
                                        that.aggiornaSaldiAccumuli(day.week, day);
                                        chkAccumulo = that.chkAccumulo(day, regola, accumuliCHK, quantitaCausale);
                                    } else {
                                        chkAccumulo = true;
                                    }
                                    if (chkAccumulo && chkOreLavorate && chkMancanti && chkAltroGiu) {
                                        // Applica giustificativo
                                        const causale = PresenzeGiustificativo.factory({codGiu: regola.codGiu});
                                        causale.tipoGiu = GiustificativoRecord.getTipoGiu(giustificativo)!;
                                        let pos;
                                        if (GiustificativoRecord.isOrario(giustificativo)) {
                                            PresenzeGiustificativo.setHHCC(causale, quantitaCausale);
                                            pos = -1;
                                            for (let ind0 = 0; pos === -1 && ind0 < newCausaliHH.length; ++ind0) {
                                                if (newCausaliHH[ind0].codGiu === causale.codGiu) {
                                                    pos = ind0;
                                                }
                                            }
                                            if (pos === -1) {
                                                newCausaliHH.push(causale);
                                                ++countNewCausaliHH;
                                            } else {
                                                newCausaliHH[pos] = causale;
                                            }
                                        } else {
                                            causale.quantita = quantitaCausale;
                                            pos = -1;
                                            for (let ind0 = 0; pos === -1 && ind0 < newCausaliQI.length; ++ind0) {
                                                if (newCausaliQI[ind0].codGiu === causale.codGiu) {
                                                    pos = ind0;
                                                }
                                            }
                                            if (pos === -1) {
                                                newCausaliQI.push(causale);
                                                ++countNewCausaliQI;
                                            } else {
                                                newCausaliQI[pos] = causale;
                                            }
                                        }
                                        insNewCausali();
                                    }
                                }
                            } else {
                                // 27/12/2021: hot fix per sostituire MLT con il giustificativo da status per ricovero!
                                if (day.causaliHH[posCausaleMLT]) {
                                    day.causaliHH[posCausaleMLT]!.codGiu = regola.codGiu;
                                }
                            }
                        }
                    }
                } else {
                    console.warn('Non è stato specificato un giustificativo!');
                }
            }
            /*
                    const count = day.addCausaliHH(newCausaliHH, that.gestione.maxCausaliOre);
                    count += day.addCausaliQI(newCausaliQI, GestionePlus.maxCausaliQI);
                    if (count < newCausaliHH.length + newCausaliQI.length) {
                        console.error(GestionePlus.formatDate(day.dtGiornata), 'Raggiunto il limite massimo di causali!');
                        day.setAnomalia(11);
                    }
            */
            if ((countHH + countQI) < (countNewCausaliHH + countNewCausaliQI)) {
                console.warn(GestionePlus.formatDate(day.dtGiornata), 'Raggiunto il limite massimo di causali o causale scartata!');
                PresenzeGiornataPlusRecord.setAnomalia(day, 11);
            }
            result.count = countHH;
            result.countQI = countQI;
        }

        return result;
    };

    public chkAccumulo = function (day: PresenzeGiornataPlusRecord, regola: GiustificazioneAutoRecord, accumuliCHK: AccumuloRecord[], quantitaCausale: number) {
        if (regola.controlloAccumulo !== 'NESSUN_CONTROLLO') {
            for (let ind0 = 0; ind0 < accumuliCHK.length; ++ind0) {
                const accumulo = accumuliCHK[ind0];
                if (accumulo.id === regola.codiceAccumulo) {
                    if (AccumuloRecord.isValidInPeriodo(accumulo, day)) {
                        let valCausale = 0;
                        for (let ind1 = 0; ind1 < accumulo.listaGiu.length; ++ind1) {
                            if (accumulo.listaGiu[ind1].id === regola.codGiu) {
                                switch (accumulo.listaGiu[ind1].operazione) {
                                    case 1:
                                        valCausale = quantitaCausale;
                                        break;
                                    case 2:
                                        valCausale = -quantitaCausale;
                                        break;
                                    case 3:
                                        // assegnazione NON gestita
                                        break;
                                    case 4: // Conta
                                        valCausale = 1;
                                        break;
                                }
                                break;
                            }
                        }
                        const esitoAccumulo = AccumuloRecord.applicaCriterio(accumulo, accumulo.saldoPeriodo + valCausale, day.totali!);
                        return (regola.controlloAccumulo === 'SE_VERO' && esitoAccumulo) || (regola.controlloAccumulo === 'SE_FALSO' && !esitoAccumulo);
                    } else {
                        return false;
                    }
                }
            }

        } else {
            return true;
        }

        return false;
    };

    private aggiornaSaldiAccumuli = (weekRif: StatoWeekPLUSRecord | null, dayRif: PresenzeGiornataPlusRecord | null = null) => {
        Accumuli.aggiornaSaldiAccumuli({
            ...this.gestione,
            currentWeek: dayRif!.week // todo da verificare!
        }, weekRif, dayRif);
    }
}